"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompactSlider = void 0;
const react_1 = __importStar(require("react"));
const public_1 = require("../../common/public");
const CompactSlider_styles_1 = require("./CompactSlider.styles");
const checkCompactSliderProps_1 = require("./helpers/checkCompactSliderProps");
const getCompactSliderValue_1 = require("./helpers/getCompactSliderValue");
const getInternalPercentValue_1 = require("./helpers/getInternalPercentValue");
const CompactSliderMode_1 = require("./types/CompactSliderMode");
const helpers_1 = require("../Slider/helpers/helpers");
const helpers_2 = require("../../helpers");
const mathSign_1 = require("../../helpers/mathSign");
const styles_1 = require("../../helpers/styles");
const StackView_1 = require("../../StackView");
exports.CompactSlider = (0, helpers_2.createUIElement)('CompactSlider', (_a, ref) => {
    var { className, value = 0, disabled = false, startValue = 0, endValue = 100, minLimit, maxLimit, step, onChange, valueControlRenderer, size = public_1.CONTROL_SIZE.s, onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "value", "disabled", "startValue", "endValue", "minLimit", "maxLimit", "step", "onChange", "valueControlRenderer", "size", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const internalMinLimit = (0, react_1.useMemo)(() => minLimit || startValue, [minLimit, startValue]);
    const internalMaxLimit = (0, react_1.useMemo)(() => maxLimit || endValue, [endValue, maxLimit]);
    const internalStep = (0, react_1.useMemo)(() => step || 1, [step]);
    (0, checkCompactSliderProps_1.checkCompactSliderProps)(startValue, internalMinLimit, internalMaxLimit, endValue, internalStep);
    const minMaxLength = (0, react_1.useMemo)(() => endValue - startValue, [endValue, startValue]);
    const mode = (0, react_1.useMemo)(() => (step ? CompactSliderMode_1.COMPACT_SLIDER_MODE.discrete : CompactSliderMode_1.COMPACT_SLIDER_MODE.continuous), [step]);
    const internalPercentMin = (0, react_1.useMemo)(() => (0, getInternalPercentValue_1.getInternalPercentValue)(internalMinLimit, startValue, minMaxLength), [internalMinLimit, minMaxLength, startValue]);
    const internalPercentMax = (0, react_1.useMemo)(() => (0, getInternalPercentValue_1.getInternalPercentValue)(internalMaxLimit, startValue, minMaxLength), [internalMaxLimit, minMaxLength, startValue]);
    const internalPercentStep = (0, react_1.useMemo)(() => (100 * internalStep) / minMaxLength, [internalStep, minMaxLength]);
    const limitedValue = (0, react_1.useMemo)(() => (0, helpers_1.getLimitedValue)({ min: internalMinLimit, value, max: internalMaxLimit }), [internalMaxLimit, internalMinLimit, value]);
    const limitedValueRef = (0, react_1.useRef)(limitedValue);
    (0, react_1.useEffect)(() => {
        limitedValueRef.current = limitedValue;
    }, [limitedValue]);
    const internalPercentValue = (0, react_1.useMemo)(() => (0, getInternalPercentValue_1.getInternalPercentValue)(value, startValue, minMaxLength), [minMaxLength, startValue, value]);
    const trackRef = (0, react_1.useRef)(null);
    const thumbRef = (0, react_1.useRef)(null);
    const removeListenerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = removeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(removeListenerRef);
        };
    }, []);
    const controlMouseDownHandler = (0, react_1.useCallback)((e) => {
        if (trackRef.current === null || removeListenerRef.current) {
            return;
        }
        const startClientX = e.clientX;
        const trackWidth = trackRef.current.clientWidth;
        let newValue = (0, getCompactSliderValue_1.getCompactSliderValue)(internalPercentValue, startValue, minMaxLength);
        const mouseMoveHandler = (event) => {
            if (disabled) {
                return;
            }
            const clientXDelta = event.clientX - startClientX;
            const direction = (0, mathSign_1.mathSign)(clientXDelta);
            const newPercentPosition = (0, helpers_1.getNewPositionThumb)(internalPercentValue, trackWidth, clientXDelta, internalPercentMax, internalPercentMin);
            const newPercentValue = (0, helpers_1.getValueFromPositionThumb)(internalPercentValue, newPercentPosition, internalPercentStep, direction);
            newValue = (0, getCompactSliderValue_1.getCompactSliderValue)(newPercentValue, startValue, minMaxLength);
            if (limitedValueRef.current !== newValue) {
                onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
            }
            if (thumbRef.current) {
                thumbRef.current.style.left = `calc(${newPercentPosition}% - (${CompactSlider_styles_1.compactSliderThumbSize} * ${newPercentPosition})/100))`;
            }
        };
        const mouseHandler = () => {
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
            if (thumbRef.current) {
                thumbRef.current.style.left = '';
            }
            if (removeListenerRef.current) {
                removeListenerRef.current();
                removeListenerRef.current = null;
            }
        };
        window.document.addEventListener('mousemove', mouseMoveHandler);
        window.document.addEventListener('mouseleave', mouseHandler);
        window.document.addEventListener('mouseup', mouseHandler);
        removeListenerRef.current = () => {
            window.document.removeEventListener('mousemove', mouseMoveHandler);
            window.document.removeEventListener('mouseleave', mouseHandler);
            window.document.removeEventListener('mouseup', mouseHandler);
        };
    }, [
        disabled,
        internalPercentMax,
        internalPercentMin,
        internalPercentStep,
        internalPercentValue,
        minMaxLength,
        onChange,
        startValue
    ]);
    const trackAreaMouseUpHandler = (0, react_1.useCallback)((e) => {
        var _a;
        if (disabled) {
            return;
        }
        const trackRect = (_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const trackWidth = trackRect === null || trackRect === void 0 ? void 0 : trackRect.width;
        const trackLeft = trackRect === null || trackRect === void 0 ? void 0 : trackRect.left;
        const clientX = e === null || e === void 0 ? void 0 : e.nativeEvent.pageX;
        if (clientX !== undefined && trackLeft !== undefined && trackWidth !== undefined) {
            const trackAreaClickCoordinateX = clientX - trackLeft;
            const countPoints = minMaxLength / internalStep;
            const firstNumberInteractablePoint = Math.abs(((internalMinLimit - startValue) * countPoints) / minMaxLength);
            const lastNumberInteractablePoint = Math.abs(((internalMaxLimit - startValue) * countPoints) / minMaxLength);
            const numberPoint = (trackAreaClickCoordinateX * countPoints) / trackWidth;
            const filteredNumberPointByFirstLastInteractablePoints = Math.max(Math.min(numberPoint, lastNumberInteractablePoint), firstNumberInteractablePoint);
            const nearestNumberPhysicalVisiblePoint = filteredNumberPointByFirstLastInteractablePoints <
                Math.trunc(filteredNumberPointByFirstLastInteractablePoints) + 0.5
                ? Math.trunc(filteredNumberPointByFirstLastInteractablePoints)
                : Math.trunc(filteredNumberPointByFirstLastInteractablePoints) + 1;
            onChange === null || onChange === void 0 ? void 0 : onChange(nearestNumberPhysicalVisiblePoint * internalStep + startValue);
        }
    }, [
        disabled,
        internalMaxLimit,
        internalMinLimit,
        internalStep,
        minMaxLength,
        onChange,
        startValue
    ]);
    const options = (0, react_1.useMemo)(() => {
        const result = [];
        for (let value = internalMinLimit; value <= internalMaxLimit; value += internalStep) {
            result.push({ value });
        }
        return result;
    }, [internalMaxLimit, internalMinLimit, internalStep]);
    const temporaryPercentValue = (0, react_1.useMemo)(() => (0, getInternalPercentValue_1.getInternalPercentValue)(limitedValue, startValue, minMaxLength), [limitedValue, minMaxLength, startValue]);
    const pointElements = (0, react_1.useMemo)(() => {
        const result = [];
        if (mode === CompactSliderMode_1.COMPACT_SLIDER_MODE.discrete) {
            options.map(({ value }) => {
                const pointPercentValue = (0, getInternalPercentValue_1.getInternalPercentValue)(value, startValue, minMaxLength);
                result.push(react_1.default.createElement(CompactSlider_styles_1.StyledCompactSliderPoint, { key: `point${value}`, leftValue: pointPercentValue, isFilled: temporaryPercentValue >= pointPercentValue, disabled: disabled, interactiveMode: !disabled && value !== limitedValue, onClick: () => {
                        if (!disabled) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(value);
                        }
                    } }));
            });
        }
        return result;
    }, [
        disabled,
        limitedValue,
        minMaxLength,
        mode,
        onChange,
        options,
        startValue,
        temporaryPercentValue
    ]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'compact-slider-wrapper', [initialDataSelectorId]);
    const sliderSize = (0, react_1.useMemo)(() => (typeof size === 'string' ? size : (0, styles_1.calcWidth)(size)), [size]);
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_2.cn)('vm-CompactSlider', className) }),
        react_1.default.createElement(CompactSlider_styles_1.StyledCompactSliderWrapper, { size: sliderSize },
            react_1.default.createElement(CompactSlider_styles_1.StyledCompactSliderTrackArea, { fillPercent: temporaryPercentValue, ref: trackRef, disabled: disabled, onMouseUp: trackAreaMouseUpHandler },
                react_1.default.createElement(CompactSlider_styles_1.StyledCompactSliderTrackLine, null),
                pointElements,
                react_1.default.createElement(CompactSlider_styles_1.StyledCompactSliderControl, { "data-selector-id": "compact-slider-control", position: temporaryPercentValue, disabled: disabled, onMouseDown: controlMouseDownHandler, ref: thumbRef }))),
        valueControlRenderer &&
            valueControlRenderer({
                disabled,
                options,
                value: limitedValue,
                onValueChange: onChange
            })));
});
//# sourceMappingURL=CompactSlider.js.map